import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
   background: rgb(235, 235, 235);
`

function correctName(name) {
  switch (name.toLowerCase()) {
    case 'задняя': {
      return 'задние'
    }
    case 'передняя': {
      return 'передние'
    }
    default :
      return name
  }
}

export default function Tabs({tabs, selected, setSelected, autosize = false}) {
  return (
    <Container>
      {
        tabs.map(t => {
          return (
            <div
              style={{
                ...(autosize && {width: `${100 / tabs.length}%`}),
                display: 'inline-block',
                padding: 10,
                textAlign: 'center',
                ...(t == selected
                  ? {
                    color: 'white',
                    background: '#173DB0',
                  }
                  : {
                    cursor: 'pointer',
                    color: 'black',
                    background: 'rgb(235, 235, 235)',
                  }),
              }}
              onClick={() => {
                setSelected(t)
              }}
            >
              {correctName(t)}
            </div>
          )
        })
      }
    </Container>
  )
}


// WEBPACK FOOTER //
// ./src/basic/Tabs.js